<ubs-ofbiz-form [ofbizForm]="ofbizForm" [title]="title" [isLookup]="isLookup" (setFormData)="setFormData($event)"></ubs-ofbiz-form>
